/**
 * 가격을 원화 형식으로 포맷팅
 * @param price - 포맷팅할 가격
 * @returns 포맷팅된 가격 문자열 (예: ₩50,000)
 */
export const formatPrice = (price: number): string => {
  return `₩${Math.floor(price).toLocaleString()}`;
};

/**
 * 잔고를 원화 형식으로 포맷팅
 * @param balanceValue - 포맷팅할 잔고
 * @returns 포맷팅된 잔고 문자열 (예: ₩10,000,000)
 */
export const formatBalance = (balanceValue: number): string => {
  return `₩${Math.floor(balanceValue).toLocaleString()}`;
};

/**
 * 초를 분:초 형식으로 포맷팅
 * @param seconds - 포맷팅할 초
 * @returns 포맷팅된 시간 문자열 (예: 5:30)
 */
export const formatTime = (seconds: number): string => {
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${mins}:${secs.toString().padStart(2, '0')}`;
};

